import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import axiosInstance from "../../../../hooks/axiosInstance";
import { toast } from "react-toastify";
import { Col, Spinner } from "react-bootstrap";
import { COUNTRY_CODES } from "../../../../constants/countryCodes";
// import "./Style.css";

export default function CreateSubAccount({ ShowSubAccount, closeModal, baseUserId, refreshPage, existingBaseUsers = [] }) {
    const [validationError, setValidationError] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const countryCodes = COUNTRY_CODES;
    const [toggles, setToggles] = useState([]); // Individual toggle state for each sub-account password

    const [subAccount, setSubAccount] = useState([
        {
            id: null,
            first_name: "",
            last_name: "",
            phone: "",
            country_code: "+234", // Default to USA
            email: "",
            status: "",
            password: "",
        },
    ]);

    // Prepopulate form with existingBaseUsers
    useEffect(() => {
        if (Array.isArray(existingBaseUsers) && existingBaseUsers.length > 0) {
            const populatedSubAccounts = existingBaseUsers.map((user) => {
                const phone = user.phone || "";
                let country_code = "+1"; // Default to USA
                let phone_number = phone;

                // Find matching country code
                const matchedCountry = countryCodes.find((country) =>
                    phone.startsWith(country.code)
                );
                if (matchedCountry) {
                    country_code = matchedCountry.code;
                    phone_number = phone.slice(country_code.length);
                } else if (phone.startsWith("+")) {
                    const possibleCode = phone.match(/^\+\d{1,4}/)?.[0];
                    if (possibleCode) {
                        country_code = possibleCode;
                        phone_number = phone.slice(possibleCode.length);
                    }
                }

                return {
                    id: user.id || null,
                    first_name: user.first_name || "",
                    last_name: user.last_name || "",
                    phone: phone_number,
                    country_code,
                    email: user.email || "",
                    status: user.status || "",
                    password: "", // Password typically not prepopulated for security
                };
            });
            setSubAccount(populatedSubAccounts);
            setToggles(new Array(populatedSubAccounts.length).fill(false)); // Initialize toggles
        }
    }, [existingBaseUsers, countryCodes]);

    const resetForm = () => {
        setSubAccount([
            {
                id: null,
                first_name: "",
                last_name: "",
                phone: "",
                country_code: "+234", 
                email: "",
                status: "",
                password: "",
            },
        ]);
        setToggles([false]);
        setValidationError({});
    };

    const handleToggle = (index) => {
        setToggles((prev) => {
            const newToggles = [...prev];
            newToggles[index] = !newToggles[index];
            return newToggles;
        });
    };

    const handleChange = (index, e) => {
        const { name, value } = e.target;
        const newSubAccount = [...subAccount];
        if (name === "phone") {
            // Allow only numbers for phone
            newSubAccount[index][name] = value.replace(/[^0-9]/g, "");
        } else {
            newSubAccount[index][name] = value;
        }
        setSubAccount(newSubAccount);
    };

    const handleAddSubAccount = () => {
        setSubAccount([
            ...subAccount,
            {
                id: null,
                first_name: "",
                last_name: "",
                phone: "",
                country_code: "+234", 
                email: "",
                status: "",
                password: "",
            },
        ]);
        setToggles([...toggles, false]);
        setValidationError({});
    };

    const handleRemoveSubAccount = (index) => {
        setSubAccount(subAccount.filter((_, i) => i !== index));
        setToggles(toggles.filter((_, i) => i !== index));
    };

    const handleClose = () => {
        resetForm();
        closeModal();
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            const data = subAccount.map((detail) => ({
                ...detail,
                base_user_id: baseUserId,
                phone: `${detail.country_code}${detail.phone}`,
            }));

            await axiosInstance.post("/user/sub_account/add_sub_account", { details: data });
            toast.success("Sub Accounts saved successfully!");
            handleClose();
            if (refreshPage) refreshPage();
        } catch (error) {
            console.error("Error submitting form:", error);
            if (error.response && error.response.data.errors) {
                setValidationError(error.response.data.errors);
                toast.error("Failed to save sub accounts.");
            } else {
                toast.error("An error occurred while saving sub accounts.");
            }
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="CreateCompanyDetail">
            <Modal show={ShowSubAccount} onHide={handleClose} dialogClassName="modal-lg">
                <Form onSubmit={handleSubmit}>
                    <Modal.Header closeButton>
                        <Modal.Title>Add Sub Account</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="card-body">
                            {subAccount.map((detail, index) => (
                                <div
                                    key={index}
                                    className="mb-4"
                                    style={{ border: "1px solid #405189", padding: "1rem" }}
                                >
                                    <div className="text-center">
                                        <b style={{ fontSize: "20px" }}>Sub-Account {index + 1}</b>
                                    </div>
                                    <Form.Group className="mb-3" controlId={`formFirstName${index}`}>
                                        <Form.Label>First Name</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Enter..."
                                            name="first_name"
                                            value={detail.first_name}
                                            onChange={(e) => handleChange(index, e)}
                                            required
                                        />
                                        {validationError[`details.${index}.first_name`] && (
                                            <small className="text-danger my-1">
                                                {validationError[`details.${index}.first_name`][0]}
                                            </small>
                                        )}
                                    </Form.Group>
                                    <Form.Group className="mb-3" controlId={`formLastName${index}`}>
                                        <Form.Label>Last Name</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Enter..."
                                            name="last_name"
                                            value={detail.last_name}
                                            onChange={(e) => handleChange(index, e)}
                                            required
                                        />
                                        {validationError[`details.${index}.last_name`] && (
                                            <small className="text-danger my-1">
                                                {validationError[`details.${index}.last_name`][0]}
                                            </small>
                                        )}
                                    </Form.Group>
                                    <Form.Group className="mb-3" controlId={`formEmail${index}`}>
                                        <Form.Label>Email</Form.Label>
                                        <Form.Control
                                            type="email"
                                            placeholder="Enter..."
                                            name="email"
                                            value={detail.email}
                                            onChange={(e) => handleChange(index, e)}
                                            required
                                        />
                                        {validationError[`details.${index}.email`] && (
                                            <small className="text-danger my-1">
                                                {validationError[`details.${index}.email`][0]}
                                            </small>
                                        )}
                                    </Form.Group>
                                    <Form.Group className="mb-3" controlId={`formPhone${index}`}>
                                        <Form.Label>Phone</Form.Label>
                                        <div className="input-group">
                                            <select
                                                name="country_code"
                                                value={detail.country_code}
                                                onChange={(e) => handleChange(index, e)}
                                                className="form-control"
                                                style={{ width: "5%" }}
                                            >
                                                {countryCodes.length === 0 ? (
                                                    <option>Loading...</option>
                                                ) : (
                                                    countryCodes.map((country) => (
                                                        <option key={country.code} value={country.code}>
                                                            {country.label}
                                                        </option>
                                                    ))
                                                )}
                                            </select>
                                            <Form.Control
                                                type="tel"
                                                placeholder="Enter phone number..."
                                                name="phone"
                                                value={detail.phone}
                                                onChange={(e) => handleChange(index, e)}
                                                required
                                            />
                                        </div>
                                        {validationError[`details.${index}.phone`] && (
                                            <small className="text-danger my-1">
                                                {validationError[`details.${index}.phone`][0]}
                                            </small>
                                        )}
                                    </Form.Group>
                                    <Form.Group className="mb-3" controlId={`formStatus${index}`}>
                                        <Form.Label>Status</Form.Label>
                                        <Form.Select
                                            name="status"
                                            value={detail.status}
                                            onChange={(e) => handleChange(index, e)}
                                            required
                                        >
                                            <option value="">-- Select Status --</option>
                                            <option value="active">Active</option>
                                            <option value="inactive">Inactive</option>
                                        </Form.Select>
                                        {validationError[`details.${index}.status`] && (
                                            <small className="text-danger my-1">
                                                {validationError[`details.${index}.status`][0]}
                                            </small>
                                        )}
                                    </Form.Group>
                                    <Col md={12} lg={12} xs={12} sm={12} className="mb-2">
                                        <div className="position-relative auth-pass-inputgroup">
                                            <Form.Label>Create Password</Form.Label>
                                            <input
                                                type={toggles[index] ? "text" : "password"}
                                                className="form-control pe-5 password-input"
                                                placeholder="Enter password"
                                                name="password"
                                                value={detail.password}
                                                onChange={(e) => handleChange(index, e)}
                                                required
                                            />
                                            <button
                                                className="btn btn-link position-absolute end-0 text-decoration-none text-muted password-addon"
                                                style={{ top: "30px" }}
                                                type="button"
                                                onClick={() => handleToggle(index)}
                                            >
                                                <i
                                                    className={`${toggles[index] ? "ri-eye-off-fill" : "ri-eye-fill"} align-middle`}
                                                ></i>
                                            </button>
                                            {validationError[`details.${index}.password`] && (
                                                <small className="text-danger my-1">
                                                    {validationError[`details.${index}.password`][0]}
                                                </small>
                                            )}
                                        </div>
                                    </Col>
                                    {subAccount.length > 1 && (
                                        <div className="d-flex justify-content-end">
                                            <Button
                                                variant="danger"
                                                onClick={() => handleRemoveSubAccount(index)}
                                            >
                                                Remove
                                            </Button>
                                        </div>
                                    )}
                                </div>
                            ))}
                            <Button variant="primary" onClick={handleAddSubAccount}>
                                Add Another Account
                            </Button>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            Cancel
                        </Button>
                        <Button
                            style={{ backgroundColor: "#c4281b", color: "#fff" }}
                            type="submit"
                            disabled={isLoading}
                        >
                            {isLoading ? (
                                <>
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />{" "}
                                    Saving...
                                </>
                            ) : (
                                "Save"
                            )}
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        </div>
    );
}